export const PRODUCTS_QUERY_CACHE_EXPIRE_TIME_MS = 600000; // 10 minutes
export const CATEGORIES_QUERY_CACHE_EXPIRE_TIME_MS = 86400000; //day
export const APP_SETTINGS_QUERY_CACHE_EXPIRE_TIME_MS = 86400000; //day
export const USERS_QUERY_CACHE_EXPIRE_TIME_MS = 86400000; //day
export const BANNERS_QUERY_CACHE_EXPIRE_TIME_MS = 86400000; //day
export const SHIPPING_ZONES_QUERY_CACHE_EXPIRE_TIME_MS = 86400000; //day
export const PAYMENT_METHODS_QUERY_CACHE_EXPIRE_TIME_MS = 86400000; //day
export const SHIPPING_METHODS_QUERY_CACHE_EXPIRE_TIME_MS = 86400000; //day
export const PRODUCT_QUERY_CACHE_EXPIRE_TIME_MS = 600000; // 10 minutes
export const ORDERS_QUERY_CACHE_EXPIRE_TIME_MS = 600000; // 10 minutes
export const SHIPPING_DELIVERY_DATES_INTERVALS_CACHE_EXPIRE_TIME_MS = 600000; // 10 minutes
export const DEFAULT_CART_REMIND_DELAY_MINUTES = 180;
export const REVIEW_ORDER_SET_QUERY_CACHE_EXPIRE_TIME_MS = 86400000; //day
export const UNPAID_ORDERS_QUERY_CACHE_EXPIRE_TIME_MS = 600000; // 10 minutes
export const RESEND_SMS_CODE_DELAY_MS = 60000; //60 seconds
export const CUSTOMER_SURVEY_CACHE_EXPIRE_TIME_MS = 60000; // 60 seconds
export const ADDRESSES_CACHE_EXPIRE_TIME_MS = 600000; // 10 minutes
export const GET_HOME_PAGE_CACHE_EXPIRE_TIME_MS = 600000; // 30 minutes
export const UNREAD_COUNT_CACHE_EXPIRE_TIME_MS = 120000; // 2 minutes
export const NOTIFICATION_TYPES_CACHE_EXPIRE_TIME_MS = 10 * 60 * 1000; // 10 minutes
export const NOTIFICATION_TYPES_STALE_TIME_MS = 5 * 60 * 1000; // 5 minutes
export const NOTIFICATIONS_CACHE_EXPIRE_TIME_MS = 5 * 60 * 1000; // 5 minutes
export const NOTIFICATIONS_STALE_TIME_MS = 2 * 60 * 1000; // 2 minutes
export const PAGE_ITEMS_QUERY_CACHE_EXPIRE_TIME_MS = 300000; // 5 minutes